import { useTranslation } from "@i18n";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import SignDraw from "@CubeComponents/html/signDraw";
import type { SignatureComponentRef } from "@CubeComponents/Mui_Form/SignatureComponent";
import { useRef, useState } from "react";

type DrawSignatureProps = {
  /** Render the stored signature read-only instead of the drawing canvas. */
  previewMode?: boolean;
  defaultImage?: string;
  drawSignatureCallback?: (args: { base64ImageStr: string }) => void;
};

function DrawSignature({ previewMode = false, defaultImage, drawSignatureCallback }: DrawSignatureProps) {
  const { t } = useTranslation();
  const signRef = useRef<SignatureComponentRef | null>(null);
  const [createdSignature, setCreatedSignature] = useState(defaultImage);

  const clearSignatureHandler = () => {
    signRef.current!.clear();
    handleCreated(null!);
  };

  const handleCreated = (data: string) => {
    setCreatedSignature(data);
    if (drawSignatureCallback) {
      drawSignatureCallback({ base64ImageStr: data });
    }
  };

  return (
    <div className="w-full">
      {!previewMode ? (
        <>
          <SignDraw ref={signRef} setCreatedSignature={handleCreated} initialImageUrl={defaultImage} />
          <div className="flex items-center justify-between pt-2">
            <ButtonComponent
              buttonType={BUTTON_TYPES.TEXT_BUTTON}
              onClick={clearSignatureHandler}
              disabled={!createdSignature}
            >
              {t("Clear")}
            </ButtonComponent>
          </div>
        </>
      ) : (
        <div>
          <div className="border border-[#c6d0df]">
            <img src={createdSignature} />
          </div>
        </div>
      )}
    </div>
  );
}

export default DrawSignature;
